<template>
  <div>
    <div
      class="card !border-none mb-3"
      style="width: 100%"
      v-loading="loading"
      :element-loading-text="loadingText"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="card-header bg-white !px-3 !py-3">
        <h3 class="title fw-normal mb-0">Internal Chat</h3>
      </div>

      <div class="card-body">
        <el-switch
          v-if="!loading"
          v-model="appMode"
          @change="updateInternalChat"
          active-color="var(--brand-500)"
          inactive-color="var(--black-200)"
          active-text="Enabled"
          inactive-text="Disabled"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { postAPICall } from '@/helpers/httpHelper';
  import { mapGetters } from 'vuex';

  export default {
    name: 'InternalChat',
    data() {
      return {
        loading: false,
        loadingText: 'Loading...',
        appMode: false,
        botId: null,
      };
    },
    computed: {
      ...mapGetters('auth', ['getActiveWorkspace', 'getAuthenticatedUser']),
    },
    async mounted() {
      await this.fetchStatus();
    },
    methods: {
      async fetchStatus() {
        this.loading = true;
        try {
          const res = await postAPICall('GET', '/bot/get-Bot');
          if (res && res.success && res.data) {
            this.botId = res.data._id;
            this.appMode = !!res.data.internal_chat_enabled;
            localStorage.setItem('internal_chat_enabled', String(this.appMode));
          } else {
            this.appMode = false;
            localStorage.setItem('internal_chat_enabled', 'false');
          }
        } catch (e) {
          this.appMode = false;
          localStorage.setItem('internal_chat_enabled', 'false');
          console.warn('No existing bot record found. Will create when toggled.');
        } finally {
          this.loading = false;
        }
      },

      async updateInternalChat(value) {
        this.loading = true;
        const payload = {
          internal_chat_enabled: value,
          workspace: this.getActiveWorkspace,
          userId: this.getAuthenticatedUser._id,
        };

        try {
          let res;
          if (this.botId) {
            res = await postAPICall('PUT', `/bot/update/${this.botId}`, payload);
          } else {
            res = await postAPICall('POST', '/bot/create', payload);
            if (res && res.success && res.data?._id) {
              this.botId = res.data._id;
            }
          }

          if (res && res.success) {
            localStorage.setItem('internal_chat_enabled', String(value));

            this.$confirm(
              "Your chatbot settings have been updated. We're applying the new configurations and will reload your workspace. Please wait a moment.",
              'Confirmation',
              {
                type: 'warning',
                confirmButtonText: 'Reload Now',
                cancelButtonText: 'Cancel',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
              }
            )
              .then(() => {
                location.reload();
              })
              .catch(() => {
                this.$message.info('You canceled the reload.');
              });
          } else {
            this.$message.error(res.message || 'Failed to save internal chat setting.');
          }
        } catch (e) {
          console.error(e);
          this.$message.error('Error saving internal chat setting.');
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .card-body {
    padding: 25px;
  }
</style>
